<template>
  <div>
 
 
 <!-- start company info header -->

  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>

  <!-- end company info header -->
  

  
  <div  id="pdfDocumentDownloadLink" style="text-align:center;margin-bottom:50px;font-weight:bold"></div>
  <div  id="pdfDocument"></div>

	
	
	
	
	 
	<div>
	 <p-button type="danger"  @click="deleteDocument()" >
                <i slot="label" class="nc-icon nc-simple-remove"></i>
                Delete Document
     </p-button>
    
     
	</div>    
	
	
	<div style="margin-bottom:150px;"></div>
	
  </div>
</template>
<script>
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  export default {
    components: {

    },
    
     mounted() {
     
			let uri = this.$base_url+'/api/v1/documents/get/get_common/'+ this.$route.params.cdid;
			 ApiService.get(uri).then(response => {
				this.createForm = false
				this.coy = response.data.entity;
				let file = response.data.document;
				this.doc = response.data.doc_obj;
				
		
				if(this.doc.format=="pdf"){
					let b64 = file;
				
					// Embed the PDF into the HTML page and show it to the user
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.type = 'application/pdf';
					obj.data = 'data:application/pdf;base64,' + b64;
					document.getElementById("pdfDocument").appendChild(obj);
					
					// Insert a link that allows the user to download the PDF file
					var link = document.createElement('a');
					link.innerHTML = 'Download PDF file';
					link.download = this.coy.uen+'_document.pdf';
					link.href = 'data:application/octet-stream;base64,' + b64;
					document.getElementById("pdfDocumentDownloadLink").appendChild(link);
				}
				else if(this.doc.format=="jpeg" || this.doc.format=="jpg" || this.doc.format=="png"){
					let b64 = file;
				
					var obj = document.createElement('object');
					obj.style.width = '100%';
					obj.style.height = '842pt';
					obj.type = 'application/'+this.doc.format;
					obj.src = 'data:image/jpeg;base64,,' + b64;
					
					
					var img = document.createElement("img");
					img.src = 'data:image/'+this.doc.format+';base64,'+b64
					document.getElementById("pdfDocument").append(img);
					
					
					
					// Insert a link that allows the user to download the PDF file
					var link = document.createElement('a');
					link.innerHTML = 'Download file';
					link.download = this.coy.uen+'_document.'+this.doc.format;
					link.href = 'data:application/octet-stream;base64,' + b64;
					document.getElementById("pdfDocumentDownloadLink").appendChild(link);
				}
				
			
			})//end resposne
      	
      	
      	
      
    },
    
     
    data () {
      return {
    	doc:{
    		document_name:'',
    		notes:'',    		
    	},

    	coy:[],

      }
    },
    computed: {
  			
     
    },
    methods:{
    
   
    	deleteDocument(){
    		
			 
			 const vm = this;
			 swal({
				title: 'Are you sure?',
				text: 'You won\'t be able to revert this!',
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
				confirmButtonText: 'Yes, delete it!',
				buttonsStyling: false
          	}).then(function () {
             	let uri = vm.$base_url+'/api/v1/documents/delete/common_document/'+ vm.$route.params.cdid;
				 ApiService.post(uri).then(response => {
				 	if(vm.doc.parent_type == 1){
				 		vm.$router.push( '/view-compliance-update/'+vm.doc.parent_id)
				 	}
					
				 })
         
            
          })// end swal
    	
    	},
     	goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      
      
    },

    
  }
</script>
<style>
  
</style>


